export enum MyGalaEnums {
    GALABINGO = 'galabingo',
    BINGO = 'bingo',
    CASINO = 'casino',
    FREEOFFERS = 'freeoffers',
}
